import employerIdentificationNumberValidator from './validator/employer-identification-number-validator';
import { createAlphanumericFormatter } from '@philips-internal/oswald-ui-model/lib/generators/';
export const EMPLOYER_IDENTIFICATION = 'employee-identification-number';
const EmployerIdentificationNumberFormatter = createAlphanumericFormatter({
    invalidMessage: 'hpms-formatter.employee-identification-number.invalid',
    mask: '00.000.000/0000-00',
    name: EMPLOYER_IDENTIFICATION,
    validate: employerIdentificationNumberValidator,
});
export default EmployerIdentificationNumberFormatter;
//# sourceMappingURL=employer-identification-number-formatter.js.map